export default __webpack_public_path__ + "static/media/icon_burger_menu.22cdad28.svg";